import isEqual from 'lodash/isEqual';
import get from 'lodash/get';
import * as utils from './Utils';



export function formatCartItem(itemRow) {
  let item = {};
  item['id'] = `${itemRow.id}`;
  item['title'] = itemRow.title;
  item['quantity'] = itemRow.quantity;
  item['price'] = parseFloat(itemRow.price);
  item['product_id'] = `${itemRow.product_id}`;
  item['product_title'] = itemRow.product_name;
  item['variant_id'] = `${itemRow.variant_id}`;
  item['variant_title'] = itemRow.variant_name;
  return item;
}

export function flattenCartItems(response) {
  let flattenItems = [];

  if (!response.items) return [];
  response.items.forEach((itemRow) => {
    if (!itemRow.items) {
      flattenItems.push(itemRow);
      return;
    }

    itemRow.items.forEach((subItem) => {
      flattenItems.push(subItem);
    })
  })

  return flattenItems;
}

export function formatCartResponse(response) {
  let data = {};
  data['currency'] = response.currency;
  data['total_price'] = response.total_price ? parseFloat(response.total_price) : parseFloat(0);
  data['total_discount'] = response.total_discount ? parseFloat(response.total_discount) : parseFloat(0);

  let cartItems = flattenCartItems(response);
  let items = [];
  cartItems.forEach((itemRow) => {
    let item = formatCartItem(itemRow);
    items.push(item);
  })

  data['items'] = items;
  return data;
}


function getAddedCartItems(response) {
  const existingData = get(window.OnVoardEventsData, 'easystore_cart', {});

  const existingMapper = {};
  if (existingData.items) {
    existingData.items.forEach((itemRow) => {
      if (itemRow.freebie) return;
      existingMapper[`${itemRow.i_id}`] = parseInt(itemRow.quantity);
    })
  }

  let cartItems = flattenCartItems(response);
  const currentMapper = {};
  cartItems.forEach((itemRow) => {
    if (itemRow.freebie) return;
    currentMapper[`${itemRow.i_id}`] = parseInt(itemRow.quantity);
  })

  let addedIds = utils.getAddedCartItemIds(existingMapper, currentMapper);
  let addedItems = [];
  cartItems.forEach((itemRow) => {
    let itemId = `${itemRow.i_id}`;
    if (!addedIds.includes(itemId)) return;
    addedItems.push(itemRow)
  })

  return addedItems;
}

export function handleCartUpdate(response) {
  let noChange = isEqual(window.OnVoardEventsData['easystore_cart'], response);
  let isNew = !window.OnVoardEventsData['easystore_cart'] ? true : false;

  // no cart change
  if (noChange) return;

  // if first time loading, don't dispatch added cart items
  let addedCartItems = [];
  if (!isNew) addedCartItems = getAddedCartItems(response);

  window.OnVoardEventsData['easystore_cart'] = response;
  utils.dispatchCartUpdateEvent(response);
  addedCartItems.forEach((item) => {
    utils.dispatchAddCartItemEvent(item);
  })
}

export function setupCartUpdateEvent() {
  if (window.OnVoardEventsData.setupCartUpdateEvent) return;
  window.OnVoardEventsData.setupCartUpdateEvent = true;

  // Important: For EasyStore, don't intercept request on checkout page as it will cause some bugs with their promotion feature.
  if (window.EasyStore.Checkout) return;

  let cartUpdatePaths = [
    "/cart/add?retrieve=true",
    "/cart?retrieve=true",
    "/new_cart?retrieve=true",
    "/cart/remove_item_quantity?retrieve=true",
    "/cart/apply_cart_voucher_code?retrieve=true",
    "/new_cart/update",
  ];

  utils.interceptRequests(cartUpdatePaths, (response, url) => {
    response = utils.parseResponse(response);
    if (!response) return;
    if (response.status === 'error') return;
    handleCartUpdate(response.cart || response);
  });

  // turn off because causing issues with promotion
  // const easyStoretriggerPaths = [
  //   "/cart/add",
  // ];

  // let triggerCartUpdate = () => {
  //   utils.getRq({
  //     "url": "/cart?retrieve=true",
  //     "headers": {
  //       "x-requested-with": "XMLHttpRequest",
  //     },
  //     "successCallback": (response) => {
  //       response = utils.parseResponse(response);
  //       if (!response) return;
  //       if (response.status === 'error') return;
  //       handleCartUpdate(response);
  //     },
  //     "errorCallback": () => {}
  //   });
  // };

  // utils.interceptRequests(easyStoretriggerPaths, (response, url) => {
  //   triggerCartUpdate();
  // });
}

export function loadCart() {
  // Important: For EasyStore, don't load cart on checkout page as it will cause some bugs with their promotion feature.
  if (window.EasyStore.Checkout) return;

  let cartPayload = null;
  if (!cartPayload && typeof global_cart !== 'undefined' && global_cart) cartPayload = global_cart;

  if (cartPayload && cartPayload.cart) {
    let response = utils.parseResponse(cartPayload.cart);
    handleCartUpdate(response);
    return;
  }

  let successCallback = (response) => {
    response = utils.parseResponse(response);
    if (!response) return;
    if (response.status === 'error') return;
    handleCartUpdate(response.cart || response);
  };

  let errorCallback = () => {};

  utils.getRq({
    "url": "/cart?retrieve=true",
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "headers": {
      "x-requested-with": "XMLHttpRequest"
    }
  });
}

